import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import axios from 'axios';

const guideFlag = 'my_travel_plans_page_guide_viewed';

const getOnboarding = (user) => {
  if (!user || !user.onboarding_flags) {
    return {};
  }

  if (typeof user.onboarding_flags === 'object') {
    return user.onboarding_flags;
  }

  try {
    return JSON.parse(user.onboarding_flags);
  }
  catch (error) {
    return {};
  }
};

const startMyTravelPlansGuide = (user, options = {}) => {
  const {
    i18n,
    onFinish = () => {},
    endpoint = `${process.env.VUE_APP_APP_URL}/api/user-settings/onboarding-flags`,
  } = options;

  if (!i18n) {
    return;
  }

  if (getOnboarding(user)[guideFlag]) {
    return;
  }

  const hasTable = Boolean(document.querySelector('.my-travel-plans-guide-table'));
  const editBtnElement = document.querySelector('.my-travel-plans-guide-edit-btn');
  const actionsBtnElement = document.querySelector('.my-travel-plans-guide-actions-btn');

  if (!hasTable) {
    return;
  }

  let isCompleted = false;
  let onboardingDriver = null;

  const completeGuide = () => {
    isCompleted = true;
    if (onboardingDriver) {
      onboardingDriver.destroy();
    }
  };

  const steps = [
    {
      element: '.my-travel-plans-guide-table',
      popover: {
        title: i18n.t('my_travel_plans.guide.table_title'),
        description: i18n.t('my_travel_plans.guide.table_description'),
      },
    },
    ...(editBtnElement ? [{
      element: editBtnElement,
      popover: {
        title: i18n.t('my_travel_plans.guide.edit_title'),
        description: i18n.t('my_travel_plans.guide.edit_description'),
      },
    }] : []),
    ...(actionsBtnElement ? [{
      element: actionsBtnElement,
      popover: {
        title: i18n.t('my_travel_plans.guide.actions_title'),
        description: i18n.t('my_travel_plans.guide.actions_description'),
      },
    }] : []),
  ];

  if (!steps.length) {
    return;
  }

  steps[steps.length - 1].popover.onDoneClick = completeGuide;

  onboardingDriver = driver({
    showProgress: true,
    allowClose: false,
    overlayOpacity: 0.5,
    showButtons: ['previous', 'next'],
    prevBtnText: i18n.t('Back'),
    nextBtnText: i18n.t('Next'),
    doneBtnText: i18n.t('my_travel_plans.guide.done'),
    steps,
    onDestroyed: () => {
      if (isCompleted) {
        axios.post(endpoint, {
          flags: { [guideFlag]: true },
        }).then(() => {
          onFinish();
        }).catch(() => {});
      }
    },
  });

  window.requestAnimationFrame(() => onboardingDriver.drive());
};

export default startMyTravelPlansGuide;
